import { Component, Input, OnInit } from '@angular/core'
import { LogEvent } from 'src/app/interfaces/log'
import { ShareOptions } from 'src/app/interfaces/main'
import { GeneralService } from 'src/app/services/general/general.service'
import { LogService } from 'src/app/services/log/log.service'
import { RouterService } from 'src/app/services/router/router.service'
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service'
import { UserService } from 'src/app/services/user/user.service'
import { Header } from './header'

/**
 * deprecated
 */

@Component({
  selector: 'my-header',
  template: `
    <ng-container *ngIf="this.isGnb">
      <gnb-header>
        <ng-container button>
          <!-- my 페이지 -->
          <div
            class="button"
            click
            [elementName]="'share'"
            (throttledClick)="onClickShare()"
            *ngIf="this.isApp || shareApi"
          >
            <img [src]="'assets/icons/' + (this.isApp ? 'menu' : 'web') + '/icon-share.png' | imageUrl" alt="share" />
          </div>
          <div *ngIf="this.isApp" class="button" click [elementName]="'setting'" (throttledClick)="onClickSetting()">
            <img [src]="'assets/icons/menu/icon-setting.png' | imageUrl" alt="setting" />
          </div>
        </ng-container>
      </gnb-header>
    </ng-container>
    <ng-container *ngIf="!this.isGnb">
      <app-header [webType]="'defaultA'">
        <ng-container button>
          <!-- my 페이지 -->
          <div
            class="button"
            click
            [elementName]="'share'"
            (throttledClick)="onClickShare()"
            *ngIf="this.isApp || shareApi"
          >
            <img [src]="'assets/icons/' + (this.isApp ? 'menu' : 'web') + '/icon-share.png' | imageUrl" alt="share" />
          </div>
          <div *ngIf="this.isApp" class="button" click [elementName]="'setting'" (throttledClick)="onClickSetting()">
            <img [src]="'assets/icons/menu/icon-setting.png' | imageUrl" alt="setting" />
          </div>
        </ng-container>
      </app-header>
    </ng-container>
  `,
  styleUrls: ['./header.component.scss'],
})
export class MyHeaderComponent extends Header implements OnInit {
  @Input() title = ''
  @Input() shareOptions: ShareOptions | undefined
  shareApi = navigator.share
  isGnb = false

  constructor(
    public userService: UserService,
    protected generalService: GeneralService,
    protected logService: LogService,
    private routerService: RouterService,
    private snackbarService: SnackbarService
  ) {
    super(generalService, logService)
  }

  ngOnInit(): void {
    if (location.href.includes('gnb')) {
      this.isGnb = true
    }
  }

  onClickShare(): void {
    if (this.shareOptions === undefined) {
      this.snackbarService.openSnackBar(SnackbarService.CREATE_SHARE_LINK_DATA_FAILED)
      return
    }
    this.generalService.share(this.shareOptions)
    this.logService.eventLogging(LogEvent.PROFILE_LINK_SHARE_CLICKED, { screenName: 'profile' })
  }

  onClickSetting(): void {
    this.routerService.navigate('setting')
    this.logService.eventLogging(LogEvent.PROFILE_SETTINGS_CLCICKED, { screenName: 'profile' })
  }
}
